// src/ai/estimators/offerHelperEstimator.js

export function evaluateOffer(product, offerAmount, options = {}) {
  if (!product || !offerAmount) return { ok: false };

  const cost = Number(product.trueCostPerPiece || product.costPerPiece || 0);
  const qty = Number(product.quantity || 1);

  const totalCost = cost * qty;
  const margin = offerAmount > 0 ? 1 - totalCost / offerAmount : 0;

  const targetMargin = options.targetMargin ?? 0.5;
  const minHourly = options.minHourly ?? null;
  const estHours = product.estimatedHours || null;

  let classification = "fair";
  if (margin >= targetMargin + 0.15) classification = "great";
  else if (margin >= targetMargin) classification = "fair";
  else classification = "low";

  const suggestedCounters = [];
  const counterAtTargetMargin = Math.ceil(totalCost / (1 - targetMargin));
  suggestedCounters.push({
    label: `Counter at $${counterAtTargetMargin} (target margin ${Math.round(targetMargin * 100)}%)`,
    amount: counterAtTargetMargin,
  });

  if (estHours && minHourly) {
    const targetRevenue = estHours * minHourly;
    const counterAtHourly = Math.ceil(targetRevenue);
    suggestedCounters.push({
      label: `Counter at $${counterAtHourly} (meet ${minHourly}/hr)`,
      amount: counterAtHourly,
    });
  }

  return {
    ok: true,
    costPerPiece: cost,
    quantity: qty,
    totalCost,
    offerAmount,
    offerMargin: margin,
    classification,
    suggestedCounters,
    targetMargin,
    minHourlyRate: minHourly,
  };
}
